import { render, staticRenderFns } from "./AccountAddAction.vue?vue&type=template&id=3f354502"
import script from "./AccountAddAction.vue?vue&type=script&lang=js"
export * from "./AccountAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports